import React from 'react';
import { Outlet } from 'react-router-dom';
import './style.scss';

// Each signup screen paints its own full page (purple entry vs white app
// pages), so this route shell only loads the styles.
function Signup() {
  return <Outlet />;
}

export default Signup;
